import { Fragment } from 'react';
import { RemainderDropdown } from './RemainderDropdown';
import { RepeatReminderDropdown } from './RepeatReminderDropdown';
export function ReminderField() {
    return (<Fragment>
      <RemainderDropdown />
      <RepeatReminderDropdown />
    </Fragment>);
}
